module.exports = __webpack_public_path__ + "static/media/medium.f1c256ef.svg";